import { useCallback } from 'react';

import type { ScrollLockIdE } from 'declarations/enums/scroll';

type UseScrollLockT = {
  enableScroll: (id: ScrollLockIdE) => void;
  disableScroll: (id: ScrollLockIdE) => void;
};

const scrollClassPrefix = 'scroll-lock';
const bodyElement = document.body;

const useScrollLock = (): UseScrollLockT => {
  const enableScroll = useCallback((id: ScrollLockIdE) => {
    bodyElement.classList.remove(`${scrollClassPrefix}-${id}`);
  }, []);
  const disableScroll = useCallback((id: ScrollLockIdE) => {
    bodyElement.classList.add(`${scrollClassPrefix}-${id}`);
  }, []);

  return {
    enableScroll,
    disableScroll,
  };
};

export default useScrollLock;
